import { Button } from "primereact/button";
import { Editor } from "primereact/editor";
import { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { findSettingsByKey, findSettingsByUserIdAndKey, findUpdateAndCreateSettings } from "../../service/common/commonService";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import { MailTempPreview } from "../../components/mailTemplatePreview/MailTemplatePreview"
import { AppMode } from "../../data/AppMode";
import { Themes } from "../../data/Themes";
import { AppModeState } from "../../dtos/common/AppModeState";
import { ThemeState } from "../../dtos/common/ThemeState";
import { Mail_Template } from "../../shared/constant/MailValue"
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toolbar } from "primereact/toolbar";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const MailTemplate = () => {
    const themeName = useSelector((state: ThemeState) => state.theme.themeName);
    const ThemeColors = Themes.find((th) => th.name === themeName);
    const modeName = useSelector((state: AppModeState) => state.theme.appMode);
    const mode = AppMode.find((md) => md.name === modeName);
    const [showPreview, setShowPreview] = useState(false);
    const dispatch = useDispatch();
    const toast = useRef<any>(null);
    const [text, setText] = useState('');
    const [initialized, setInitialized] = useState(false);
    const localization = useSelector(
        (state: any) => state.localization.localization
    );

    const handleText = async () => {
        const storedUserId = localStorage.getItem("userId");
        if (!storedUserId) return "UserId is not available, unable to fetch settings.";

        const userId = JSON.parse(storedUserId);

        const mailTemp = await findSettingsByUserIdAndKey(dispatch, { userId:null,key: Mail_Template });
        setText(mailTemp?.value);
        setInitialized(true);
    }

    const addEmpName = () => {
        const userNamePlaceholder = "#empName#";
        setText((prevText) => {
            // Find the last occurrence of </p> in the string
            const lastPTagIndex = prevText.lastIndexOf('</p>');

            // Concatenate the userNamePlaceholder after the last </p> tag
            const newText =
                lastPTagIndex !== -1
                    ? prevText.slice(0, lastPTagIndex) + ` ${userNamePlaceholder}</p>`
                    : `${prevText} ${userNamePlaceholder}`;

            return newText;
        });
    }

    const addEmailId = () => {
        const subordinatesPlaceholder = "#emailId#";
        setText((prevText) => {
            // Find the last occurrence of </p> in the string
            const lastPTagIndex = prevText.lastIndexOf('</p>');

            // Concatenate the userNamePlaceholder after the last </p> tag
            const newText =
                lastPTagIndex !== -1
                    ? prevText.slice(0, lastPTagIndex) + ` ${subordinatesPlaceholder}</p>`
                    : `${prevText} ${subordinatesPlaceholder}`;

            return newText;
        });
    }

    const handlePreviewBtn = () => {
        setShowPreview(true);
    }

    const handleSaveBtn = () => {
        confirmDialog({
            message: 'Are you sure you want change the mail template?',
            className: 'confirm_dialog_custom',
            icon: 'pi pi-exclamation-triangle',
            header: 'Confirmation',
            headerStyle: { backgroundColor: mode?.backgroundSecondaryColor, color: mode?.color },
            style: { width: '350px', backgroundColor: mode?.backgroundSecondaryColor, color: mode?.color },
            contentStyle: { backgroundColor: mode?.backgroundSecondaryColor, color: mode?.color,marginTop:'20px' },
            acceptClassName: 'p-button-danger',
            accept,
            reject
        });
    }

    const accept = async () => {
        const isPresentEmpName = text.includes("#empName#");
        const isPresentSub = text.includes("#emailId#");
        const userId = localStorage.getItem("userId")
        const tenantId = localStorage.getItem("tenantId")

        if (!isPresentEmpName || !isPresentSub) {
            toast.current.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please add the variables(employee name and email id)!',
                life: 3000
            });
            return;
        }
        if (userId && tenantId) {
            const mailTempInput = {
                userId: null,
                tenantId: JSON.parse(tenantId),
                name: Mail_Template,
                value: text
            }
            await findUpdateAndCreateSettings(dispatch, mailTempInput);
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'You have successfully update the mail template!'
            });
        }
    }

    const reject = () => {
        toast.current.show({
            severity: 'warn',
            summary: 'Rejected',
            detail: 'You have rejected the process',
            life: 3000
        });
    }

    const startToolBar = () => {
        return (
            <div>
                <h4 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-0 mt-0">
                    {localization?.MailTemplate || "Mail Template"}
                </h4>
            </div>
        );
    }

    useEffect(() => {
        handleText();
    }, []);

    return (
        <div className="w-full">
            <Toolbar className="bg-transparent border-0 p-0 mb-4" start={startToolBar} />

            <Card
                style={{ backgroundColor: mode?.backgroundSecondaryColor, color: mode?.color }}
                className="shadow-lg rounded-lg border border-blue-200 overflow-hidden card_content_padding "
            >
                <ConfirmDialog />
                <Toast ref={toast} />

                <div className="p-0">
                    {/* Action Buttons Section */}
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4 border-b border-gray-200 dark:border-gray-700">
                        <div className="flex flex-col sm:flex-row gap-3">
                            <Button
                                label="Add Employee Name Field"
                                onClick={addEmpName}
                                className="px-4 py-2 bg-transparent text-gold text-sky-700 border border-gold rounded-md transition-colors duration-200 text-sm font-medium"
                            />
                            <Button
                                label="Add Email"
                                onClick={addEmailId}
                                className="px-4 py-2 bg-transparent text-gold border border-gold rounded-md transition-colors duration-200 text-sm font-medium"
                            />
                        </div>

                        <Button
                            type="button"
                            aria-label="Preview Template"
                            onClick={handlePreviewBtn}
                            className="p-2 bg-violet-100 dark:bg-violet-500/20 hover:bg-violet-200 dark:hover:bg-violet-500/30 text-violet-700 dark:text-violet-300 border border-violet-300 dark:border-violet-500/40 rounded-md transition-colors duration-200 w-10 h-10 flex items-center justify-center"
                            tooltip="Preview Template"
                            tooltipOptions={{ position: 'left' }}
                        >
                            <FontAwesomeIcon icon={faEye} />
                        </Button>
                    </div>

                    {/* Editor Section */}
                    <div className="mb-6">
                        <div className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg">
                            {initialized && (
                                <Editor
                                    value={text}
                                    onTextChange={(e: any) => setText(e.htmlValue)}
                                    style={{
                                        height: '400px',
                                        backgroundColor: mode?.backgroundSecondaryColor,
                                        color: mode?.color
                                    }}
                                    className="w-full"
                                />
                            )}
                        </div>

                        {!initialized && (
                            <div className="flex items-center justify-center h-96 bg-gray-50 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg">
                                <div className="text-center">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-3"></div>
                                    <p className="text-gray-600 dark:text-gray-400">Loading template...</p>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Save Button */}
                    <div className="flex justify-start">
                        <Button
                            label="Save"
                            onClick={handleSaveBtn}
                            className="px-6 py-2 bg-gold text-white rounded-md transition-colors duration-200 font-medium min-w-20"
                        />
                    </div>
                </div>

                {/* Preview Dialog */}
                <Dialog
                    header="Mail Body Preview"
                    className="w-full sm:max-w-4xl max-w-[90%]"
                    style={{ backgroundColor: mode?.backgroundSecondaryColor, color: mode?.color }}
                    contentStyle={{
                        backgroundColor: mode?.backgroundSecondaryColor,
                        color: mode?.color,
                        maxHeight: '70vh',
                        overflow: 'auto'
                    }}
                    headerStyle={{
                        backgroundColor: mode?.backgroundSecondaryColor,
                        color: mode?.color,
                        borderBottom: `1px solid ${modeName === 'dark' ? 'rgba(255,255,255,0.12)' : '#e5e7eb'}`
                    }}
                    visible={showPreview}
                    onHide={() => setShowPreview(false)}
                    breakpoints={{ '960px': '90vw', '640px': '95vw' }}
                    modal
                >
                    <div className="p-6 bg-white dark:bg-white/5 rounded-lg border border-gray-200 dark:border-white/10 min-h-64 leading-relaxed">
                        <MailTempPreview temp={text} />
                    </div>
                </Dialog>
            </Card>
        </div>
    );
}